<template>
    <div class="loader">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 130 130" style="white-space: pre;">
            <defs>
                <symbol id="sota_dot" preserveAspectRatio="none" width="100" height="100" viewBox="0 0 100 100" overflow="visible">
                    <rect width="100" height="100" :fill="color" stroke="none" transform="translate(100.5,0.5) scale(0.01,0.01) translate(-50,-50)" style="animation: a0_t 2.5s linear infinite both;" />
                </symbol>
            </defs>
            <use width="100" height="100" xlink:href="#sota_dot" transform="translate(80,50) translate(-50,-50)" style="animation: a1_t 2.5s linear infinite both;" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'loader',
    props: {
        color: {
            type: String,
            default: "black"
        }
    }
}
</script>

<style lang="scss" scoped>
.loader {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -50px;
    margin-left: -50px;
    width: 100px;
    height: 100px;
}

@keyframes a0_t {
    0% {
        transform: translate(100.5px, 0.5px) scale(0.01, 0.01) translate(-50px, -50px);
        animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    40% {
        transform: translate(50px, 50px) scale(1, 1) translate(-50px, -50px);
        animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    80% {
        transform: translate(0.05px, 100.049998px) scale(0.001, 0.001) translate(-50px, -50px);
    }
    100% {
        transform: translate(0px, 100px) scale(0, 0) translate(-50px, -50px);
    }
}

@keyframes a1_t {
    0% {
        transform: translate(30px, 0px);
    }
    80% {
        transform: translate(0px, 30px);
    }
    100% {
        transform: translate(0px, 30px);
    }
}
</style>
